// extracted by mini-css-extract-plugin
export default {"previewRoot":"quick-pricer-print_previewRoot__ZSXda","toolbar":"quick-pricer-print_toolbar__VGEPZ","documentScrollArea":"quick-pricer-print_documentScrollArea__fd9NK"};